export const ADD_TO_CART = "cart/add";
export const REMOVE_FROM_CART = "cart/remove";
export const DELETE_ITEM = "cart/delete";